// Implements: F-UIX-018, F-RPT-009
/**
 * The client of the scope exports (UIX.5, RPT.8): the export twin of each report of the scope on
 * screen, `…/{report}/export?format=csv|json`, the consumption with the grouping on screen.
 *
 * Every address is built from the target the caller passes, ids escaped. The server decides
 * access before anything else (the report's identical `404`) and refuses a result above its row
 * cap with a `422` (`TOO_MANY_ROWS`) that names no file; the download raises it as an `ApiError`.
 */

import { httpDownload } from "../../../shared/api/httpClient";
import type { Download } from "../../../shared/api/httpClient";
import type { ConsumptionGrouping, ExportFormat, ExportReport, ReportTarget } from "../../../types/reports";
import { reportBaseOf } from "./scopeReportsApi";

export function exportPath(
  target: ReportTarget,
  report: ExportReport,
  format: ExportFormat,
  grouping: ConsumptionGrouping,
): string {
  const params = new URLSearchParams();
  if (report === "consumption") params.set("scope", grouping);
  params.set("format", format);
  return `${reportBaseOf(target)}/${report}/export?${params.toString()}`;
}

export function downloadScopeExport(
  target: ReportTarget,
  report: ExportReport,
  format: ExportFormat,
  grouping: ConsumptionGrouping,
): Promise<Download> {
  return httpDownload(exportPath(target, report, format, grouping));
}
